<template>
    <router-view/>
</template>

<style lang="scss">

@import "~bootstrap-icons/font/bootstrap-icons.css";
@import "~apexcharts/dist/apexcharts.css";
@import "~quill/dist/quill.snow.css";
@import "~animate.css";
@import "~sweetalert2/dist/sweetalert2.css";
@import "~nouislider/distribute/nouislider.css";
@import "~@fortawesome/fontawesome-free/css/all.min.css";
@import "~socicon/css/socicon.css";
@import "~line-awesome/dist/line-awesome/css/line-awesome.css";
@import "~@yaireo/tagify/src/tagify.scss";
@import "~dropzone/dist/dropzone.css";
@import "~@vueform/multiselect/themes/default.css";
@import "~prism-themes/themes/prism-shades-of-purple.css";
@import "~element-plus/dist/index.css";

// Main demo style scss
@import "assets/sass/plugins";
@import "assets/sass/style";

// Dark mode demo style scss
//@import "assets/sass/plugins.dark";
//@import "assets/sass/style.dark";

//RTL version styles
//@import "assets/css/style.rtl.css";

@import "assets/css/app.css";
@import "assets/css/dark.css";
@import "assets/css/midnight.css";
@import "assets/css/cream.css";

</style>

<script>
import {Actions, Mutations} from "@/store/enum/StoreEnums";
import UserConfigService from "@/core/services/UserConfigService";

export default {
    name: "app",
    data() {
        return {
            unitTypes: [],
            loadedInitialize: false,
            flagPath: "/media/flags/by-language-code/%s.svg",
            appUrl: process.env.VUE_APP_URL,
            filterWithUrl: true,
        }
    },
    computed: {
        currentUser() {
            return this.$store.getters.currentUser;
        }
    },
    created() {
        this.$store.dispatch(Actions.VERIFY_AUTH).then((response) => {
            if (response && response.status && !this.loadedInitialize) {
                this.initialize();
            }
        });
    },
    mounted() {
        this.$store.commit(Mutations.OVERRIDE_LAYOUT_CONFIG);
        if (this.$store.getters.isUserAuthenticated && !this.loadedInitialize) {
            this.initialize();
        }

        this.eventBus.$on('setModules', (value) => {
            const moduleCode = this.$route.meta?.moduleCode
            if (!moduleCode) return

            const allowedModules = this.$store.getters['company/module/moduleCodes']

            if (!allowedModules.includes(moduleCode)) {
                this.$router.replace('/dashboard')
            }
        });
    },
    methods: {
        initialize() {
            UserConfigService.init(this.$handler);

            this.$store.dispatch("common/unit/types").then((types) => {
                this.$root.unitTypes = types;
            });

            this.loadedInitialize = true;
        },
        getFilterWithUrl(value) {
            if (this.filterWithUrl && Object.keys(this.urlParams()).length) {
                value = this.urlParams();
            }

            return value;
        },
    },
}
</script>